var _defs, _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusCentralAccessLuminousFieldDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 1200,
    viewBox: "0 0 1200 1200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55A7DF",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55A7DF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE5A9B",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE5A9B",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 360,
    r: 340,
    fill: "url(#b)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 880,
    r: 360,
    fill: "url(#p)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 650,
    r: 150,
    stroke: "#55A7DF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 650,
    r: 255,
    stroke: "#EE5A9B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 650,
    r: 365,
    stroke: "#55A7DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163 806 487-156 333-322M650 650l220 302",
    stroke: "#8BCBF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 806,
    r: 9,
    fill: "#55A7DF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 650,
    r: 13,
    fill: "#EE5A9B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 983,
    cy: 328,
    r: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870,
    cy: 952,
    r: 8,
    fill: "#55A7DF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusCentralAccessLuminousFieldDesktop);
export default __webpack_public_path__ + "static/media/andus-central-access-luminous-field-desktop.97454098d90397de9f8c1c9d8e1ad40b.svg";
export { ForwardRef as ReactComponent };